import { enableWorkRecords, completeDeleteWorkRecords } from './api/apis';
import getMultiLevelTags from './api/tag/getMultiLevelTags';
import getWorkRecord from './api/record/getWorkRecord';
import getWorkRecords from './api/record/getWorkRecords';
import { OPEN_USER_PROMPT } from './actionTypes';

/** 最近削除した項目機能Action一覧 */
export const ActionTypes = {
  // common action
  SUCCESS_API_ENABLE_WORK_RECORDS: 'trash/SUCCESS_API_ENABLE_WORK_RECORDS',
  SUCCESS_API_DELETE_WORK_RECORDS: 'trash/SUCCESS_API_DELETE_WORK_RECORDS',
  // trash action
  OPEN_TRASH: 'trash/OPEN_TRASH',
  INIT_TRASH_INFO: 'trash/INIT_TRASH_INFO',
  UPDATE_SEARCH_OPTIONS: 'trash/UPDATE_SEARCH_OPTIONS',
  CLICK_LIST_CHECKBOX: 'trash/CLICK_LIST_CHECKBOX',
  CLICK_UNSET_TAG_ONLY_CHECKBOX: 'trash/CLICK_UNSET_TAG_ONLY_CHECKBOX',
  UPDATE_EXECUTE_EVENT: 'trash/UPDATE_EXECUTE_EVENT',
  PAGENATION_SELECT_PAGE: 'trash/PAGENATION_SELECT_PAGE',
  SUCCESS_API_GET_WORK_RECORDS: 'trash/SUCCESS_API_GET_WORK_RECORDS',
  SUCCESS_API_GET_TAGS: 'trash/SUCCESS_API_GET_TAGS',
  // trash media action
  OPEN_TRASH_MEDIA: 'trash/OPEN_TRASH_MEDIA',
  INIT_TRASH_MEDIA_INFO: 'trash/INIT_TRASH_MEDIA_INFO',
  TOGGLE_MORE: 'trash/TOGGLE_MORE',
  TOGGLE_MEDIA_MAP: 'trash/TOGGLE_MEDIA_MAP',
  TOGGLE_MEDIA_FULLSCREEN: 'trash/TOGGLE_MEDIA_FULLSCREEN',
  SUCCESS_API_GET_WORK_RECORD: 'trash/SUCCESS_API_GET_WORK_RECORD',
  SUCCESS_API_GET_ALL_TAGS: 'trash/SUCCESS_API_GET_ALL_TAGS',
  CLOSE_TAG_SEARCH_DIALOG: 'trash/CLOSE_TAG_SEARCH_DIALOG',
  SEARCHBOX_UPDATE_SEARCH_TAGS: 'trash/SEARCHBOX_UPDATE_SEARCH_TAGS',
};

// 最近削除した項目画面

/**
 * 最近削除した項目画面を表示
 * @param {func} dispatch dispatch関数
 */
export const openTrash = dispatch => {
  dispatch({ type: ActionTypes.OPEN_TRASH });
};

/**
 * 最近削除した項目画面のstate初期化
 *
 * @param {func} dispatch dispatch関数
 */
export const initTrashInfo = dispatch => {
  dispatch({ type: ActionTypes.INIT_TRASH_INFO });
};

/**
 * 記録データ復元
 *
 * @param {func} dispatch dispatch関数
 * @param {string} apiToken APIトークン
 * @param {func} formatMessage メッセージ生成関数
 * @param {object} history historyオブジェクト
 * @param {object} workRecordIds 記録データID
 */
export const restoreWorkRecords = (
  dispatch,
  apiToken,
  formatMessage,
  history,
  workRecordIds,
) => {
  const promptMessage = formatMessage({ id: 'userPrompt.message.dataRestore' });
  const buttonOk = formatMessage({ id: 'userPrompt.button.restore' });
  const buttonNo = formatMessage({ id: 'userPrompt.button.noRestore' });
  const buttonArray = [
    { name: buttonOk, type: 0 },
    { name: buttonNo, type: 1 },
  ];
  const onAccept = ret => {
    if (ret === 0) {
      dispatch(
        enableWorkRecords(
          apiToken,
          ActionTypes.SUCCESS_API_ENABLE_WORK_RECORDS,
          { ids: workRecordIds },
        ),
      );
      if (history !== null) {
        history.goBack();
      }
    }
  };
  dispatch({ type: OPEN_USER_PROMPT, promptMessage, buttonArray, onAccept });
};

/**
 * 記録データ削除
 *
 * @param {func} dispatch dispatch関数
 * @param {string} apiToken APIトークン
 * @param {func} formatMessage メッセージ生成関数
 * @param {object} history historyオブジェクト
 * @param {object} workRecordIds 記録データID
 */
export const deleteWorkRecords = (
  dispatch,
  apiToken,
  formatMessage,
  history,
  workRecordIds,
) => {
  const promptMessage = [
    formatMessage({ id: 'userPrompt.message.dataCompleteDelete.1' }),
    formatMessage({ id: 'userPrompt.message.dataCompleteDelete.2' }),
  ];
  const buttonOk = formatMessage({ id: 'userPrompt.button.delete' });
  const buttonNo = formatMessage({ id: 'userPrompt.button.noDelete' });
  const buttonArray = [
    { name: buttonOk, type: 0 },
    { name: buttonNo, type: 1 },
  ];
  const onAccept = ret => {
    if (ret === 0) {
      dispatch(
        completeDeleteWorkRecords(
          apiToken,
          ActionTypes.SUCCESS_API_DELETE_WORK_RECORDS,
          { ids: workRecordIds },
        ),
      );
      if (history !== null) {
        history.goBack();
      }
    }
  };
  dispatch({ type: OPEN_USER_PROMPT, promptMessage, buttonArray, onAccept });
};

/**
 * 検索条件更新
 *
 * @param {func} dispatch dispatch関数
 * @param {object} option 検索条件
 */
export const updateSearchOptions = (dispatch, option) => {
  dispatch({ type: ActionTypes.UPDATE_SEARCH_OPTIONS, option });
};

/**
 * ToolBarイベント更新
 *
 * @param {func} dispatch dispatch関数
 * @param {string} eventValue イベント識別文字列
 */
export const updateExecuteEvent = (dispatch, eventValue) => {
  dispatch({
    type: ActionTypes.UPDATE_EXECUTE_EVENT,
    executeEvent: eventValue,
  });
};

/**
 * 未設定階層タグ絞り込みのチェックボックス選択
 *
 * @param {func} dispatch dispatch関数
 * @param {boolean} checked チェック状況
 */
export const clickUnsetTagOnlyCheckBox = (dispatch, checked) => {
  dispatch({ type: ActionTypes.CLICK_UNSET_TAG_ONLY_CHECKBOX, checked });
};

/**
 * ToolBarのチェックボックス選択
 *
 * @param {func} dispatch dispatch関数
 * @param {string} value 選択されたoption値
 * @param {boolean} checked チェック状況
 */
export const clickToolBarCheckBox = (dispatch, value, checked) => {
  dispatch({ type: ActionTypes.CLICK_LIST_CHECKBOX, value, checked });
};

/**
 * リストのチェックボックス選択
 *
 * @param {func} dispatch dispatch関数
 * @param {string} value 選択されたoption値
 * @param {boolean} checked チェック状況
 */
export const clickListCheckBox = (dispatch, value, checked) => {
  dispatch({ type: ActionTypes.CLICK_LIST_CHECKBOX, value, checked });
};

/**
 * ページ選択
 *
 * @param {func} dispatch dispatch関数
 * @param {number} page 選択されたページ番号
 */
export const selectPage = (dispatch, page) => {
  dispatch({ type: ActionTypes.PAGENATION_SELECT_PAGE, page });
};

/**
 * 最近削除した項目情報の更新
 *
 * @param {func} dispatch dispatch関数
 * @param {string} apiToken APIトークン
 * @param {object} searchOptions 検索条件
 * @param {object} selectedTagIds 記録データID配列
 */
export const updateTrashInfo = (
  dispatch,
  apiToken,
  searchOptions,
  selectedTagIds,
  targetGroupId,
) => {
  const { groupIds: timelineGroupIds, ...timelineSearchOptions } =
    searchOptions;
  const groupIds = (targetGroupId && [targetGroupId]) || timelineGroupIds;
  dispatch(
    getWorkRecords(
      apiToken,
      { ...timelineSearchOptions, groupIds },
      ActionTypes.SUCCESS_API_GET_WORK_RECORDS,
    ),
  );
  dispatch(
    getMultiLevelTags(
      apiToken,
      {
        parentIds: selectedTagIds,
        isUsable: null,
        actionType: ActionTypes.SUCCESS_API_GET_TAGS,
      },
      targetGroupId,
    ),
  );
};

// 最近削除した項目詳細画面Action

/**
 * 最近削除した項目詳細画面表示
 *
 * @param {func} dispatch dispatch関数
 */
export const openTrashMedia = dispatch => {
  dispatch({ type: ActionTypes.OPEN_TRASH_MEDIA });
};

/**
 * 最近削除した項目詳細画面のstate初期化
 *
 * @param {func} dispatch dispatch関数
 */
export const initTrashMediaInfo = dispatch => {
  dispatch({ type: ActionTypes.INIT_TRASH_MEDIA_INFO });
};

/**
 * 操作メニュー表示切り替え
 *
 * @param {func} dispatch dispatch関数
 */
export const toggleMore = dispatch => {
  dispatch({ type: ActionTypes.TOGGLE_MORE });
};

/**
 * マップ拡大縮小切り替え
 *
 * @param {func} dispatch dispatch関数
 */
export const toggleMediaMap = dispatch => {
  dispatch({ type: ActionTypes.TOGGLE_MEDIA_MAP });
};

/**
 * 記録データ拡大縮小切り替え
 *
 * @param {func} dispatch dispatch関数
 */
export const toggleMediaFullscreen = dispatch => {
  dispatch({ type: ActionTypes.TOGGLE_MEDIA_FULLSCREEN });
};

/**
 * 最近削除した項目詳細情報の更新
 *
 * @param {func} dispatch dispatch関数
 * @param {string} apiToken APIトークン
 * @param {number} id 記録データID
 * @param {object} searchOptions 検索条件
 */
export const updateTrashMediaInfo = (dispatch, apiToken, id, searchOptions) => {
  dispatch(
    getWorkRecord(
      apiToken,
      id,
      searchOptions,
      ActionTypes.SUCCESS_API_GET_WORK_RECORD,
    ),
  );
};
